export const blankReg = /(\[.*?\])/g // NOSONAR
export const blankHtmlReg = /<em>(.*?)<\/em>/g
export const blankSimbol = '???'
